import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useCheckPathAsGameCategory } from './useCheckPathAsGameCategory';

export const useCurrentPathAsGameCategory = () => {
    const { pathname } = useLocation();
    const checkPathAsGameCategory = useCheckPathAsGameCategory();

    return useMemo(() => checkPathAsGameCategory(pathname), [checkPathAsGameCategory, pathname]);
};
